/**
 * Componente Header do aplicativo Viver Espírita
 * 
 * Este componente é responsável por renderizar o cabeçalho do aplicativo, incluindo o título, subtítulo, menu de navegação e o modal de login.
 * Ele gerencia o estado do usuário logado e a exibição do modal de login.
 * Está conectado ao contexto de autenticação para gerenciar o token e os dados do usuário logado.
 */

import Menu from '../Menu';
import Login from '../Login';
import { useState } from 'react';
import './Header.css';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contextos/AuthContext'; // Importa o hook useAuth do contexto de autenticação para acessar o estado do usuário logado e funções relacionadas à autenticação

const Header = () => {
const { login, logout } = useAuth(); // Hook para acessar o contexto de autenticação
const navigate = useNavigate(); // Hook para navegação programática
// O estado do Modal vive aqui no "pai" de todos
const [modalLoginAberto, setModalLoginAberto] = useState(false);


// Estado do usuário logado, inicialmente nulo e se o usuário estiver logado, recebe os dados do usuário



  /* Função para fazer logout
  /* Chama o endpoint de logout no backend PHP e limpa o estado do usuário logado
  //* Conectada com a função de logout do contexto de autenticação para limpar o localStorage e atualizar o estado global
  */
  const handleLogout = async () => {
        
        logout(); // limpa localStorage E atualiza estado global
        navigate('/'); // Redireciona para a página inicial após o logout
    };

  const handleLogin = (dadosUsuario) => {
    
    // 1. Salva o Token (a "pulseira VIP") e os  dados básicos do usuário para o Header (Nome/Foto)
    login({ novoToken: dadosUsuario.token, dadosUsuario }); // Usa a função de login do contexto para armazenar os dados do usuário no localStorage E atualiza o estado global
    setModalLoginAberto(false); // Fecha o modal de login
  }  

  // Renderiza o cabeçalho com o título, menu
  //  e modal de login  
  return (    
        <header className="cabecalho">
            <hgroup className="titulo">
                <h1 className="titulo__principal">Viver Espírita</h1>
                <h2 className="titulo__secundario">Prática da Doutrina em nossa vida</h2>
            </hgroup>   
            {/* Passamos a função de abrir o modal para o Menu para manipular a Modal usada para Login
            Também passamos o usuário logado para o Menu para ele ajustar os itens exibidos conforme o estado de login
            */}
            <Menu 
              
              
              //Ao clicar no login, abre o modal setando o estado para true
              aoClicarLogin={() => setModalLoginAberto(true)}
              //Ao clicar no logout, chama a função handleLogout definida acima
              aoLogout={handleLogout}
              />
              {/* O Modal também fica aqui, ouvindo o estado global */}
              <Login 
                /*Importante - ao passar estes parâmetros para o componente Login estamos elevando o estado destas variáveis para este componente pai Header. Isto permite que o Header controle a exibição do modal e reaja ao sucesso do login */

                // Controla a exibição do modal conforme o estado
                exibir={modalLoginAberto} 
                aoFechar={() => setModalLoginAberto(false)} 
                // Função chamada quando o login for bem sucedido
                onLoginSuccess={(dadosUsuario) => {
                    setModalLoginAberto(false); // Fecha o modal
                    handleLogin(dadosUsuario); // Atualiza o estado do usuário logado com os dados recebidos do Login
                }}
              />
        </header>
  );
}

export default Header;